import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom";
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton";
import {
  disabledSelectState,
  professionalWaitListState,
  specialityWaitListState,
} from "../state/atoms";
import { isChangeFormSearchState } from "src/SearchHours/state/atoms";
import {
  capitalizeWords,
  finderProfessionalByName,
} from "src/shared/global/helpers";
import { hourSelectedState } from "src/store/reservation/reservationState";
import { useProfessionals } from "../hooks/useProfessionals";

const AutocompleteProfessionals = ({ size = "small", styles }) => {
  const { professionals, loading } = useProfessionals();
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const [professionalSelected, setProfessionalSelected] = useRecoilState(
    professionalWaitListState
  );
  const [specialitySelected] = useRecoilState(specialityWaitListState);

  const disableSelect = useRecoilValue(disabledSelectState);
  const [hourSelected] = useRecoilState(hourSelectedState);

  if (loading) return <AutocompleteSkeleton />;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-profesional"
        text="Nombre del especialista (Opcional)"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-profesional"
        options={professionals.map((option) => `${option.ptdNombre}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={professionalSelected.value || null}
        noOptionsText="Sin resultados"
        disabled={
          disableSelect ||
          hourSelected !== null ||
          specialitySelected.code === null
        }
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          if (reason === "clear") {
            setProfessionalSelected({
              value: "",
              code: null,
            });

            return;
          }

          if (reason === "selectOption") {
            const finderProfessional = finderProfessionalByName(
              professionals,
              value
            );
            setProfessionalSelected({
              value: value,
              code: finderProfessional?.ptdRut,
              agp_correl: finderProfessional?.agpCorrel,
            });
          }
        }}
        renderInput={(params) => (
          <TextField {...params} placeholder="Buscar" variant="outlined" />
        )}
      />
    </>
  );
};

export default AutocompleteProfessionals;
